import React from 'react';
import { dismissBootWarmupStrip } from '../lib/bootWarmupSignals';
import { BUTTON_STYLE, STRIP_STYLE } from './bootWarmupStripStyles';
import { useTranslation } from '../i18n/useTranslation';

export default function BootWarmupStrip({ visible, message, phase, onSignInAgain }) {
  const { t } = useTranslation();
  if (!visible || !message) return null;

  return (
    <div
      role="status"
      data-testid="boot-warmup-strip"
      data-phase={phase || ''}
      style={STRIP_STYLE}
    >
      <span>{phase === 'auth_failed' ? t('signInRecovery.stripFailed') : message}</span>
      {phase === 'auth_failed' && onSignInAgain && (
        <button type="button" onClick={onSignInAgain} style={{ ...BUTTON_STYLE, color: '#fff', background: 'rgba(201, 168, 76, 0.35)' }}>
          {t('signInRecovery.signInAgain')}
        </button>
      )}
      <button
        type="button"
        aria-label="Dismiss warm-up status"
        onClick={() => dismissBootWarmupStrip()}
        style={BUTTON_STYLE}
      >
        Dismiss
      </button>
    </div>
  );
}
